/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { toast } from 'common/helpers/toastConfig';
import TextInput from 'components/form/textInput';
import Gap from 'components/gap';
import { useActions } from 'common/hooks/useActions';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router';
import { RejectReasonOwnerType } from 'common/enums';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { Switch } from 'antd';

import * as S from './styles';

const CreateNewTeaboyRejectReason = () => {
  const { rejectReason }: any = useTypedSelector((state) => state.Cafeteria);
  const [status, setStatus] = useState(rejectReason?.data?.list?.isActive || false);
  const [values, setValues] = useState<any>({
    needCustomText: false,
    translations: [
      {
        language: 'en',
        translate: ''
      },
      {
        language: 'ar',
        translate: ''
      }
    ],
    ownerType: RejectReasonOwnerType.teaboy,
    isActive: status
  });

  const { rejectReasonCreateRequestAction, rejectReasonGetOneRequestAction, rejectReasonUpdateRequestAction } =
    useActions();

  const params: any = useParams();
  const navigate = useNavigate();

  const transformReasonTranslations = (reasonTranslations: any[]) => {
    const languages = ['en', 'ar'];

    return languages.map((language) => {
      const translation = reasonTranslations?.find((t) => t.language === language);
      return {
        language,
        translate: translation?.translate || ''
      };
    });
  };

  const submitHandler = (e: any, kind: string) => {
    e.preventDefault();

    const englishTitle = values?.translations?.find((t: any) => t.language === 'en')?.translate;
    if (!englishTitle) {
      toast({ model: 'error', message: 'Please enter an English title' });
      return;
    }

    const arabicTitle = values?.translations?.find((t: any) => t.language === 'ar')?.translate;
    if (!arabicTitle) {
      toast({ model: 'error', message: 'Please enter an Arabic title' });
      return;
    }

    if (kind === 'create') {
      const requestBody = {
        needCustomText: values.needCustomText,
        translations: transformReasonTranslations(values.translations),
        ownerType: values.ownerType,
        isActive: status
      };
      rejectReasonCreateRequestAction(requestBody, () => navigate('/panel/cafeteria/teaboy-cancelled-reason'));
      return;
    }

    if (kind === 'update') {
      const requestBody = {
        id: +params?.id,
        needCustomText: values.needCustomText,
        translations: values.translations,
        isActive: status
      };
      rejectReasonUpdateRequestAction(requestBody, () => navigate('/panel/cafeteria/teaboy-cancelled-reason'));
      return;
    }
  };

  useEffect(() => {
    setStatus(rejectReason?.data?.list?.isActive);
  }, [rejectReason?.data?.list?.isActive]);

  useEffect(() => {
    if (params?.id) rejectReasonGetOneRequestAction(params?.id);
  }, [params?.id]);

  useEffect(() => {
    if (params?.id && rejectReason) {
      setValues({
        ...values,
        needCustomText: rejectReason?.data?.list?.needCustomText,
        ownerType: rejectReason?.data?.list?.ownerType,
        translations: rejectReason?.data?.list?.reasonTranslations
      });
    }
  }, [params, rejectReason, values]);

  return (
    <S.Container>
      <S.Head>
        <S.Title>{params?.id ? 'Reason Details' : 'Create New Reason'}</S.Title>

        <S.SwitchContainer>
          <S.SwitchTitle style={{ color: status ? '#1DBAAF' : '#FF6464' }}>
            {status ? 'Active' : 'InActive'}
          </S.SwitchTitle>
          <Switch
            checked={status}
            size="default"
            onChange={() => setStatus(!status)}
            style={{
              backgroundColor: status ? '#1DBAAF' : '#FF6464'
            }}
          />
        </S.SwitchContainer>
      </S.Head>

      <Gap size="80px" />

      <S.Form onSubmit={(e) => submitHandler(e, params?.id ? 'update' : 'create')}>
        <S.FormBoxes>
          <TextInput
            label="English Title"
            name="en-title"
            value={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
            onChange={(e) => {
              setValues({
                ...values,
                translations: values?.translations?.map((t: any) =>
                  t.language === 'en' ? { ...t, translate: e.target.value } : t
                )
              });
            }}
            placeholder="English Title ..."
          />

          <TextInput
            label="Arabic Title"
            name="ar-title"
            value={values?.translations?.find((t: any) => t.language === 'ar')?.translate || ''}
            onChange={(e) => {
              setValues({
                ...values,
                translations: values?.translations?.map((t: any) =>
                  t.language === 'ar' ? { ...t, translate: e.target.value } : t
                )
              });
            }}
            placeholder="العنوان باللغة العربية ..."
          />
        </S.FormBoxes>

        <Gap size="20px" />
        <S.CustomCheckbox
          checked={values.needCustomText}
          onChange={(e) => {
            setValues({ ...values, needCustomText: e.target.checked });
          }}
        >
          <span className="ant-checkbox-title">Is Custom Text</span>
        </S.CustomCheckbox>

        <Gap size="55px" />
        <S.Button type="submit">Save</S.Button>
      </S.Form>
    </S.Container>
  );
};

export default CreateNewTeaboyRejectReason;
